import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { DistributePage } from "./view/DistributePage";
import HomePage from "./view/HomePage";
import SyncPage from "./view/SyncPage";
import VisionPage from "./view/VisionPage";
import ContractsPage from "./view/ContractsPage";
import LivePage from "./view/LivePage";
import ToolsPage from "./view/ToolsPage";
import TermsPage from "./view/TermsPage";
import DistributionAgreementPage from "./view/DistributionAgreementPage";
import ContactUsPage from "./view/ContactUsPage";
import ScrollToTop from "./components/SrollToTop";
import Signup from "./view/Signup";
import Login from "./view/Login";
import PrivacyPolicyPage from "./view/PrivacyPolicyPage";
import Dashboard from "./view/Dashboard";
import Admin from "./view/Admin";
import UpdatePassword from "./view/UpdatePassword";
import ResetPassword from "./view/ReserPassword";
import CustomLogin from "./view/CustomLogin";
import UpdateEmail from "./view/UpdateEmail";
import GlobalProgressBox from "./components/common/GlobalProgressBox";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login/:id" element={<CustomLogin />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/updatePassword" element={<UpdatePassword />} />
          <Route path="/updateEmail" element={<UpdateEmail />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/privacypolicy" element={<Navigate to="/privacy" replace />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/distribution-agreement" element={<DistributionAgreementPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/contactus" element={<Navigate to="/contact-us" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/distribute" element={<DistributePage />} />
          <Route path="/sync" element={<SyncPage />} />
          <Route path="/vision" element={<VisionPage />} />
          <Route path="/contracts" element={<ContractsPage />} />
          <Route path="/live" element={<LivePage />} />
          <Route path="/tools" element={<ToolsPage />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
        </Routes>
        <GlobalProgressBox />
    </Router>
  );
};

export default App;
